import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      isAuth: false,
      login: (user) => set({ user, isAuth: true }),
      logout: () => set({ user: null, isAuth: false }),
      setUser: (user) => set({ user }),
    }),
    {
      name: 'auth',
      partialize: (s) => ({ user: s.user, isAuth: s.isAuth }),
    }
  )
)
